import { stripePaymentSchema } from '@/schema/paymentSchema';
import { Token } from '@stripe/stripe-js';

export const formatStripeToken = (token: Token) => {
  if (token) {
    const { id, card } = token;

    if (!id || !card) {
      return;
    }
    return {
      paymentType: 'stripe',
      paymentMethod: 'stripe',
      stripeToken: id,
      expiryMonth: card.exp_month,
      expiryYear: card.exp_year,
      cardType: card.brand, //TODO: card type can likely be removed as the BE can get it during processing
      cardLastFour: card.last4, //TODO: card last 4 can likely be removed as the BE can get it during processing
    };
  }
};

export const validateStripeBillingFields = (
  stripeBillingFields: {
    country: string;
    postalCode: string;
    cardName: string;
  },
  onError: (errors: any) => void,
) => {
  // TODO: refactor to remove repetitive code like parseAndHandleErrors(schema, data, onError)
  try {
    stripePaymentSchema.parse(stripeBillingFields);
  } catch (errors: any) {
    if (errors.errors) {
      onError(errors);
    }
  }
};
